import React, { useState } from "react";
import { FaGift, FaAward, FaUserPlus, FaCalendarAlt } from "react-icons/fa";
import { Tabs, Tab } from "react-bootstrap";
import "./EssDashboard.css";

const todaysBirthdays = [
  { name: "John Smith", date: "Today", department: "HR", initials: "JS" },
  {
    name: "Maria Garcia",
    date: "Today",
    department: "Finance",
    initials: "MG",
  },
];

const workAnniversaries = [
  { name: "David Wilson", date: "5 Years", department: "IT", initials: "DW" },
  {
    name: "Sarah Johnson",
    date: "3 Years",
    department: "Marketing",
    initials: "SJ",
  },
];

const newJoinees = [
  {
    name: "Alex Chen",
    date: "This Week",
    department: "Engineering",
    initials: "AC",
  },
  {
    name: "Emma Davis",
    date: "This Week",
    department: "Design",
    initials: "ED",
  },
];

const upcomingBirthdays = [
  {
    name: "Michael Brown",
    date: "Tomorrow",
    department: "Sales",
    initials: "MB",
  },
  {
    name: "Lisa Anderson",
    date: "Jan 31",
    department: "Operations",
    initials: "LA",
  },
];

function PersonList({ list, icon, emptyMsg }) {
  return list?.length ? (
    list.map((person, idx) => {
      const initials = `${person.first_name?.[0] || ""}${person.last_name?.[0] || ""}`.toUpperCase();

      return (
        <div
          key={idx}
          className="d-flex align-items-center gap-3 bg-white p-3 rounded shadow-sm mb-2"
        >
          <div
            className="rounded-circle d-flex justify-content-center align-items-center text-white fw-semibold"
            style={{ width: "36px", height: "36px", backgroundColor: "#ffc107" }}
          >
            {initials}
          </div>
          <div className="flex-fill">
            <div className="d-flex align-items-center gap-2">
              {icon}
              <h6 className="mb-0 text-dark fw-medium">{`${person.first_name} ${person.last_name}`}</h6>
            </div>
            <div className="d-flex justify-content-between mt-1 small text-muted">
              <span>{person.department}</span>
              <span className="text-warning fw-medium">{person.date}</span>
            </div>
          </div>
        </div>
      );
    })
  ) : (
    <div className="text-center py-3 text-muted small">{emptyMsg}</div>
  );
}


export function EventsCard({data}) {
  const [tabKey, setTabKey] = useState("birthday");

  return (
    <div
      className="card shadow-sm h-100 border-0"
      style={{ backgroundColor: "#ffe7a059" }}
    >
      <div className="card-header bg-transparent border-0 pb-2 d-flex align-items-center gap-2">
        <FaGift className="text-warning" />
        <h5 className="mb-0 text-warning fw-semibold">Events & Celebrations</h5>
      </div>
      <div className="card-body events-tabs">
        <Tabs
          activeKey={tabKey}
          onSelect={(k) => setTabKey(k)}
          className="mb-3 custom-tabs"
      
          justify
        >
          <Tab eventKey="birthday" title="Today's Birthday">
            <PersonList
              list={data.birthdays_today}
              icon={<FaGift className="text-warning small" />}
              emptyMsg="No birthdays today"
              className="custom-tabs"
           
            />
          </Tab>
          <Tab eventKey="anniversary" title="Work Anniversary">
            <PersonList
              list={data.anniversaries_today}
              icon={<FaAward className="text-warning small" />}
              emptyMsg="No work anniversaries today"
            />
          </Tab>
          <Tab eventKey="newjoinee" title="New Joinee">
            <PersonList
              list={data.new_joiners}
              icon={<FaUserPlus className="text-warning small" />}
              emptyMsg="No new joiners this week"
            />
          </Tab>
          <Tab eventKey="upcoming" title="Upcoming Birthday" className="nowrap">
            <PersonList
              list={data.upcoming_birthdays}
              icon={<FaCalendarAlt className="text-warning small" />}
              emptyMsg="No upcoming birthdays"
            />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
